import request from '@/utils/request'
export default {
  // 查询项目列表
  getProjectList(data) {
    return request({
      url: '/system/project/list',
      method: 'post',
      data
    })
  },
  // 设为/取消队长
  setTeamHead(params) {
    return request({
      url: '/system/project/setTeamHead',
      method: 'put',
      params
    })
  },
  // 新增修改项目
  addOrEditProject(method, data) {
    return request({
      url: '/system/project',
      method,
      data
    })
  },
  // 删除项目
  delProject(id) {
    return request({
      url: `/system/project/${id}`,
      method: 'delete',
    })
  },
  // 获取项目详细信息
  getProjectDetailInfo(id) {
    return request({
      url: `/system/project/detailInfo/${id}`,
      method: 'get'
    })
  },
  // 根据RTX新增成员
  addTeamUser(params) {
    return request({
      url: '/system/project/addTeamUser',
      method: 'put',
      params
    })
  },
  // 踢出队伍
  kickOutTeam(params) {
    return request({
      url: '/system/project/kickOutTeam',
      method: 'put',
      params
    })
  },
  // 下一个评审项目
  nextReviewProject(currentProjectId) {
    return request({
      url: '/system/project/nextReviewProject',
      method: 'put',
      params: { currentProjectId }
    })
  },
  // 快速评审
  quickEvalute() {
    return request({
      url: '/system/project/quickEvaluate',
      method: 'put'
    })
  },
  // 通过评审/驳回
  reviewProject(params) {
    return request({
      url: '/system/project/review',
      method: 'put',
      params
    })
  },
  // 新增或修改项目总结
  addOrEditSummary(method, data) {
    return request({
      url: '/system/summary',
      method,
      data
    })
  },
  // 获取项目总结详细信息
  getSummary(id) {
    return request({
      url: `/system/summary/${id}`,
      method: 'get'
    })
  },
  // 数据统计
  getDataStatistics() {
    return request({
      url: '/system/project/dataStatistics',
      method: 'get'
    })
  },
  // 线下打卡
  offlinePunchTheClock(data) {
    return request({
      url: '/system/project/offlinePunchTheClock',
      method: 'post',
      data
    })
  },
  //修改线下打卡
  updateOfflinePunchTheClock(data) {
    return request({
      url: '/system/project/updateOfflinePunchTheClock',
      method: 'post',
      data
    })
  },
  // 设置投票偏移
  setVoteOffset(params) {
    return request({
      url: '/system/project/setVoteOffset',
      method: 'put',
      params
    })
  },
  // 新增或修改项目评审
  addOrEditReview(method, data) {
    return request({
      url: '/system/review',
      method,
      data
    })
  },
  // 删除项目评审
  delReview(id) {
    return request({
      url: `/system/review/${id}`,
      method: 'delete'
    })
  },
  // 查询项目列表
  getReviewList(params) {
    return request({
      url: '/system/review/list',
      method: 'get',
      params
    })
  },
  // 导出项目统计
  exportProject() {
    return process.env.VUE_APP_BASE_API + '/system/project/exportProject'
  },
  // 查询项目的评论详情
  getProjectComment(params) {
    return request({
      url:'/system/project/projectComment',
      method:'post',
      params
    })
  },
  //删除评论
  delProjectComment(id) {
    return request({
      url:`/system/comment/${id}`,
      method:'delete'
    })
  },
  //数据统计
  getDataStatistics(data) {
    return request({
      url:'/system/project/dataStatistics',
      method:'post',
      data
    })
  }
}